import { render, staticRenderFns } from "./basic-datagrid-visualizer.vue?vue&type=template&id=0455f91d&scoped=true&"
import script from "./basic-datagrid-visualizer.vue?vue&type=script&lang=js&"
export * from "./basic-datagrid-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./basic-datagrid-visualizer.vue?vue&type=style&index=0&id=0455f91d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455f91d",
  null
  
)

export default component.exports